import { useQuery, useInfiniteQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'
import { normalizeVulnData } from '@/adapters'

export const useVulnerabilityQuery = (id, options = {}) => {
  const api = useMatiApiClient('vulnerabilities')
  return useQuery({
    queryFn: () => api.getOneVulnerability(id),
    queryKey: ['getOneVulnerability', id],
    ...options,
    refetchOnWindowFocus: false,
  })
}

export const useVulnerabilitiesVocabService = (options = {}) => {
  const api = useMatiApiClient('vulnerabilities')
  return useQuery({
    queryFn: () => api.getVulnerabilityVocab(),
    queryKey: ['vulnerabilitiesVocab'],
    ...options
  })
}

export const useVulnsInfiniteQuery = (_, searchParams, ids) => {
  const limit = 50
  const queryString = getVulnsQueryString(searchParams, ids)
  const { getVulnsData } = useMatiApiClient('vulnerabilities')
  return useInfiniteQuery({
    queryKey: ['vulnerabilities', queryString, ids],
    queryFn: async ({ pageParam: offset = 0 }) => {
      const data = await getVulnsData({ queryString, offset, limit })
      const nextPage = offset + limit
      if (data.total_count > nextPage) {
        data.nextPage = nextPage
      }
      const { vulnerability: items, ...restData } = data || {}
      return {
        items: items.map(cve => normalizeVulnData(cve)),
        ...restData,
      }
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  })
}

export const getVulnsQueryString = (searchParams, ids) => {
  if (!searchParams) {
    return ''
  }
  const queryParams = new URLSearchParams(searchParams)
  if (queryParams.has('sortBy') && queryParams.get('sort')) {
    const direction = queryParams.get('sort')
    const sortField = queryParams.get('sortBy')
    queryParams.set('sort_by', `${sortField}:${direction}`)
  }
  if (ids && ids.length > 0) {
    queryParams.set('ids', ids.join(','))
  }
  return queryParams.toString()
}

export const useZeroDayExploitsData = () => {
  const api = useMatiApiClient('vulnerabilities')
  return useQuery({
    queryFn: () => api.getVulnerabilityTrends(),
    queryKey: ['getVulnerabilityTrends'],
  })
}
